"use client";
import { jsx as c } from "react/jsx-runtime";
import { css as I } from "@emotion/react";
import k from "@emotion/styled";
import { MEDIA_QUERIES as r } from "../../tokens/media-queries/MediaQueries.js";
const $ = ({ children: t, ...d }) => /* @__PURE__ */ c(u, { ...d, "data-comp": "grid-item", children: t });
$.displayName = "GridItem";
const h = $, u = k.div(
  ({ feColspan: t, feDisplay: d, feVisible: m }) => I`
		@media screen and (${r.mobileMax}) {
			display: ${(d == null ? void 0 : d.mobile) === !1 && "none"};
			grid-column: ${(t == null ? void 0 : t.mobile) && `span ${t == null ? void 0 : t.mobile}`};
			visibility: ${(m == null ? void 0 : m.mobile) === !1 && "hidden"};
		}

		@media screen and (${r.tablet}) and (${r.tabletMax}) {
			display: ${(d == null ? void 0 : d.tablet) === !1 && "none"};
			grid-column: ${(t == null ? void 0 : t.tablet) && `span ${t == null ? void 0 : t.tablet}`};
			visibility: ${(m == null ? void 0 : m.tablet) === !1 && "hidden"};
		}

		@media screen and (${r.desktop}) {
			display: ${(d == null ? void 0 : d.desktop) === !1 && "none"};
			grid-column: ${(t == null ? void 0 : t.desktop) && `span ${t == null ? void 0 : t.desktop}`};
			visibility: ${(m == null ? void 0 : m.desktop) === !1 && "hidden"};
		}
	`
);
export {
  h as default
};
